<template>
  <div
    class="card card-body card-chart d-flex justify-content-center align-items-center"
  >
    <v-loader />
  </div>
</template>

<script>
import Loader from '@/common/components/Loader.vue';

export default {
  name: 'EmptyStateWidget',
  components: {
    'v-loader': Loader,
  },
};
</script>
